import type { Material } from '#lib/mmpv/types/material.js'
import type { Catalog } from '#lib/mmpv/types/catalog.js'

export function getParentProperties(childMaterial: Material, catalog: Catalog): string[] {
	let material = childMaterial
	const propertyIds: string[] = []
	while (material.parentId !== 'root') {
		const indexOfParentMaterial = catalog.nodes
			.map((node: Material) => node.id)
			.indexOf(material.parentId)
		if (indexOfParentMaterial > -1) {
			catalog.nodes[indexOfParentMaterial].propertyIds.forEach((propertyId: string) =>
				propertyIds.push(propertyId)
			)
			material = catalog.nodes[indexOfParentMaterial]
		} else {
			break
		}
	}
	return propertyIds
}
